import styled from "@emotion/styled";

export const ReverseButton = styled.div`
  background: #172a2d;
  border-radius: 67.375px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  fill: #e9ba04;
  margin: auto;
  cursor: pointer;
  color: #38da7c !important;
  &:hover {
    background: rgba(51, 69, 69, 0.93);
    transform: rotate(180deg);
    transition: transform 0.5s ease;
  }
`;
